var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48331 9.85568C6.33594 9.68857 6.28757 9.45606 6.35613 9.24404C6.42454 9.03202 6.59965 8.87183 6.81693 8.82239C7.03408 8.77281 7.26134 8.84153 7.41488 9.00307L10.2631 12.1144V0.619537C10.2675 0.396815 10.3888 0.192795 10.5824 0.082618C10.7761 -0.0275394 11.0134 -0.0275394 11.207 0.082618C11.4007 0.192775 11.522 0.396811 11.5264 0.619537V12.1144L14.3746 9.00307C14.5277 8.83927 14.756 8.76875 14.9747 8.81787C15.1933 8.86699 15.3696 9.02839 15.4379 9.24191C15.506 9.45544 15.456 9.68902 15.3062 9.85583L11.3605 14.1657C11.241 14.2966 11.0719 14.3712 10.8947 14.3712C10.7174 14.3712 10.5483 14.2966 10.4289 14.1657L6.48331 9.85568ZM20.3684 11.3136C20.2009 11.3138 20.0404 11.3804 19.9219 11.4988C19.8035 11.6173 19.7369 11.7779 19.7369 11.9455V17.7062H1.26339V11.9455C1.25902 11.7226 1.13771 11.5187 0.944075 11.4086C0.750286 11.2984 0.512935 11.2984 0.319316 11.4086C0.125677 11.5187 0.0043672 11.7226 2.56275e-07 11.9455V18.3362C-0.000150427 18.5038 0.0661523 18.6646 0.18475 18.7833C0.303194 18.9019 0.463984 18.9685 0.631552 18.9684H20.3685C20.5359 18.9687 20.6965 18.9022 20.8151 18.7838C20.9335 18.6655 21 18.5048 21 18.3374V11.9455C20.9998 11.778 20.9332 11.6175 20.8148 11.4989C20.6965 11.3805 20.5359 11.3138 20.3685 11.3137L20.3684 11.3136Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.15c8e09e23b87d9a3b71f0a871565f96.svg";
export { ForwardRef as ReactComponent };